import React from 'react';
import PropTypes from 'prop-types';
import * as cacUtils from '../../../util/cacUtils';

const GenericColumnHeader = props => {
  const onCacGridViewSort = (key, columnIndex) => {
    let sortOrder = cacUtils.SORT_DIRECTION.DESC;
    if (
      props.sortColumnIndex === columnIndex &&
      props.sortKey === key
    ) {
      switch (props.sortOrder) {
        case cacUtils.SORT_DIRECTION.DESC:
          sortOrder = cacUtils.SORT_DIRECTION.ASC;
          break;
        case cacUtils.SORT_DIRECTION.ASC:
          sortOrder = cacUtils.SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = cacUtils.SORT_DIRECTION.DESC;
      }
    }
    const sortObj = { sortOrder, key, columnIndex };
    props.onSort(sortObj);
  };

  const {
    sortOrder,
    sortKey,
    sortColumnIndex,
    columnIndex,
    columnHeaders,
    mainHeader,
    showMainHeader,
  } = props;
  return (
    <div className='c-table--col' data-test="genColHeaderComponent">
      {showMainHeader && (
        <div className="title-container">
          <div className="title-btn" title={mainHeader.label.toUpperCase()}>
            {mainHeader.label}
          </div>
        </div>
      )}
      {
        <div className="cell gen-cell-cell">
          {columnHeaders &&
            columnHeaders.map(item => (
              <div key={item.label} className="cell--item" title={item.label}>
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  onClick={() => onCacGridViewSort(item.key, columnIndex)}
                  className="gen-column-text"
                >
                  {item.text}
                  {sortKey === item.key &&
                    sortOrder === 'desc' &&
                    sortColumnIndex === columnIndex && (
                      <i data-test="desc">▼</i>
                    )}
                  {sortKey === item.key &&
                    sortOrder === 'asc' &&
                    sortColumnIndex === columnIndex && <i data-test="asc">▲</i>}
                </button>
              </div>
            ))}
        </div>
      }
    </div>
  );
};

GenericColumnHeader.propTypes = {
  columnHeaders: PropTypes.arrayOf(PropTypes.shape({})),
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  mainHeader: PropTypes.shape({
    label: PropTypes.string
  }),
  columnIndex: PropTypes.number,
  showMainHeader: PropTypes.bool,
  onSort: PropTypes.func,
};

export default GenericColumnHeader;
